export const LANDING_PAGE_URL = window.location.host.startsWith("play")
  ? "https://www.likelystorygame.com"
  : "https://likelystory.webflow.io";
